var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 20.444a4.353 4.353 0 0 1-4.347 4.347H0V7.574a4.353 4.353 0 0 1 4.347-4.347H28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__a)",
    d: "M21.89 4.682a3.115 3.115 0 0 0-3.115 3.115v3.234h4.399c.102 0 .222 0 .308.017.992.052 1.728.565 1.728 1.455 0 .702-.496 1.3-1.42 1.42v.035c1.01.068 1.78.633 1.78 1.506 0 .941-.856 1.557-1.986 1.557h-4.826v6.333h4.57a3.115 3.115 0 0 0 3.114-3.115V4.682z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__b)",
    d: "M20.298 16.029h1.797c.026 0 .069-.005.111-.009.043-.004.086-.008.112-.008a.8.8 0 0 0 .633-.805.83.83 0 0 0-.633-.804c-.052-.017-.154-.017-.223-.017h-1.797z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__c)",
    d: "M22.095 11.973a.73.73 0 0 1 .634.736c0 .41-.291.684-.634.736-.017.017-.12.017-.17.017h-1.627v-1.506h1.626c.028 0 .067.005.102.01q.044.006.07.007"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__d)",
    d: "M4.673 4.682a3.115 3.115 0 0 0-3.115 3.115v7.684c.873.428 1.78.702 2.687.702 1.078 0 1.66-.65 1.66-1.54v-3.629h2.67v3.611c0 1.404-.873 2.55-3.833 2.55-1.798 0-3.201-.393-3.201-.393v6.555h4.57a3.115 3.115 0 0 0 3.115-3.115V4.682z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__e)",
    d: "M13.28 4.682a3.115 3.115 0 0 0-3.114 3.115v4.073c.787-.668 2.156-1.095 4.364-.993 1.181.052 2.448.377 2.448.377v1.318c-.634-.326-1.387-.616-2.362-.685-1.677-.12-2.687.702-2.687 2.14 0 1.454 1.01 2.276 2.687 2.139.975-.069 1.729-.377 2.362-.685V16.8s-1.25.325-2.448.377c-2.207.102-3.577-.326-4.364-.993v7.188h4.57a3.115 3.115 0 0 0 3.115-3.115V4.682z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__a",
    x1: 18.772,
    x2: 26.463,
    y1: 12.706,
    y2: 12.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__b",
    x1: 18.772,
    x2: 26.463,
    y1: 12.706,
    y2: 12.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__c",
    x1: 18.772,
    x2: 26.463,
    y1: 12.706,
    y2: 12.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__d",
    x1: 1.554,
    x2: 9.364,
    y1: 14.01,
    y2: 14.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__e",
    x1: 10.121,
    x2: 17.707,
    y1: 14.01,
    y2: 14.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
};
export default SvgJcb;